/**
 * eleves.js
 * ---------
 * Dossier eleve : classes, releve d'appel, sanctions, entourage.
 *
 * Extrait de `directeurApi.js` (559 lignes, toutes les fonctions ajoutees a la
 * suite). Chaque lot ajoutait ses appels en fin de fichier : deux lots ouverts
 * en meme temps entraient donc systematiquement en conflit sur ce fichier.
 * `directeurApi.js` reste le point d'entree — il re-exporte ces modules — pour
 * qu'aucun ecran n'ait a changer ses imports.
 */
import axiosClient from "../axiosClient";

/* ── Dossier élève (fiche détaillée du design) ── */

/** GET /classes/ — sert à retrouver l'id d'une classe à partir de son nom. */
export async function getClasses() {
  const { data } = await axiosClient.get("/classes/");
  return Array.isArray(data) ? data : data?.results || [];
}

/** GET /presences/?eleve=<id> — relevé d'appel d'un élève (absences et retards). */
export async function getPresencesEleve(eleveId, params = {}) {
  const { data } = await axiosClient.get("/presences/", { params: { eleve: eleveId, ...params } });
  return Array.isArray(data) ? data : data?.results || [];
}

/** GET /sanctions/?eleve=<id> — journal disciplinaire d'un élève. */
export async function getSanctionsEleve(eleveId) {
  const { data } = await axiosClient.get("/sanctions/", { params: { eleve: eleveId } });
  return Array.isArray(data) ? data : data?.results || [];
}

/** GET /directeur/eleves/<id>/entourage/ -> { eleve, responsables, equipe, manques } */
export async function getEleveEntourage(id) {
  const { data } = await axiosClient.get(`/directeur/eleves/${id}/entourage/`);
  return data || null;
}

/**
 * GET /directeur/eleves/<id>/suivi/ -> { evenements, resume, assiduite }
 * Chronologie du dossier : sanctions, convocations de la famille et messages
 * rattachés à l'élève, du plus récent au plus ancien.
 */
export async function getSuiviEleve(id) {
  const { data } = await axiosClient.get(`/directeur/eleves/${id}/suivi/`);
  return data || null;
}

/** POST /convocations/ — convoque la famille d'un élève. */
export async function creerConvocation(payload) {
  const { data } = await axiosClient.post("/convocations/", payload);
  return data;
}
